import { render, staticRenderFns } from "./UserAssignedIssueList.vue?vue&type=template&id=50c5dfe2&scoped=true"
import script from "./UserAssignedIssueList.vue?vue&type=script&lang=ts"
export * from "./UserAssignedIssueList.vue?vue&type=script&lang=ts"
import style0 from "./UserAssignedIssueList.vue?vue&type=style&index=0&id=50c5dfe2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c5dfe2",
  null
  
)

export default component.exports